<template>
  <div class="container mx-auto">
    <div class="max-w-6xl">
      <form-generator
        v-model="registrationUser"
        :schema="schema"
        @form="updateState(registrationUser)"
        @form:previous="formPrevious()"
        @form:next="formNext()"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import schema from "@/schemas/register/registerAccount";
import FormGenerator from "@/components/form/FormGenerator";

export default {
  name: "AuthRegister",
  inject: {
    $validator: "$validator"
  },
  components: {
    FormGenerator
  },
  data() {
    return {
      schema: schema
    };
  },
  computed: {
    ...mapGetters(["getRegistrationUser"]),
    registrationUser() {
      return this.getRegistrationUser;
    }
  },
  methods: {
    ...mapActions(["SAVE_REGISTRATION_FIELD"]),
    updateState(data) {
      this.SAVE_REGISTRATION_FIELD(data);
    },
    formPrevious() {
      this.$router.push({ name: "register-onboarding" });
    },
    prepopulateCommonFields() {
      [
        "greenid_passportdvs_givenname",
        "greenid_birthcertificatedvs_givenname",
        "greenid_citizenshipcertificatedvs_givenname",
        "greenid_immicarddvs_givenname",
        "greenid_visadvs_givenname",
        "greenid_actregodvs_givenname",
        "greenid_nswregodvs_givenname",
        "greenid_ntregodvs_givenname",
        "greenid_qldregodvs_givenname",
        "greenid_saregodvs_givenname",
        "greenid_tasregodvs_givenname",
        "greenid_vicregodvs_givenname",
        "greenid_waregodvs_givenname"
      ].forEach(element => {
        this.registrationUser[element] = this.registrationUser.firstName
      });

      [
        "greenid_passportdvs_middlename",
        "greenid_birthcertificatedvs_middlename",
        "greenid_citizenshipcertificatedvs_middlename",
        "greenid_immicarddvs_middlename",
        "greenid_visadvs_middlename",
        "greenid_actregodvs_middlename",
        "greenid_nswregodvs_middlename",
        "greenid_ntregodvs_middlename",
        "greenid_qldregodvs_middlename",
        "greenid_saregodvs_middlename",
        "greenid_tasregodvs_middlename",
        "greenid_vicregodvs_middlename",
        "greenid_waregodvs_middlename"
      ].forEach(element => {
        this.registrationUser[element] = this.registrationUser.middleName
      });

      // "greenid_birthcertificatedvs_surname",
      [
        "greenid_birthcertificatedvs_surname",
        "greenid_passportdvs_surname",
        "greenid_citizenshipcertificatedvs_surname",
        "greenid_immicarddvs_surname",
        "greenid_visadvs_surname",
        "greenid_actregodvs_surname",
        "greenid_nswregodvs_surname",
        "greenid_ntregodvs_surname",
        "greenid_qldregodvs_surname",
        "greenid_saregodvs_surname",
        "greenid_tasregodvs_surname",
        "greenid_vicregodvs_surname",
        "greenid_waregodvs_surname"
      ].forEach(element => {
        this.registrationUser[element] = this.registrationUser.lastName
      });

      [
        "greenid_passportdvs_dob",
        "greenid_birthcertificatedvs_dob",
        "greenid_citizenshipcertificatedvs_dob",
        "greenid_immicarddvs_dob",
        "greenid_visadvs_dob",
        "greenid_actregodvs_dob",
        "greenid_nswregodvs_dob",
        "greenid_ntregodvs_dob",
        "greenid_qldregodvs_dob",
        "greenid_saregodvs_dob",
        "greenid_tasregodvs_dob",
        "greenid_vicregodvs_dob",
        "greenid_waregodvs_dob",
        "greenid_medicaredvs_dob",
        "greenid_centrelinkdvs_dob"	
      ].forEach(element => {
        this.registrationUser[element] = this.registrationUser.dateOfBirth
      });

      ["greenid_centrelinkdvs_nameOnCard", "greenid_medicaredvs_nameOnCard"]
      .forEach(element => {
        this.registrationUser[element] = 
            [this.registrationUser?.firstName, this.registrationUser?.middleName, this.registrationUser?.lastName]
              .filter(e => (!!e?.length))
              .join(" ")
      });
    },
    formNext() {
      this.prepopulateCommonFields();
      this.$router.push({ name: "register-identity-onboarding" });
    }
  }
};
</script>

<style lang="scss" scoped></style>
